import React from 'react'
import { arrow_tip_dark } from '../../assets/images'

const DropdownTable = ({status, count, showItem }) => {
  
  return (
    <div>
      <div
        className='group items-start font-bold focus:outline-none focus:ring-0 -mb-2 cursor-pointer'
        aria-controls='sub-menu-1'
        aria-expanded='false'
      >
        <div className='w-full bg-white text-base p-6 flex flex-row border rounded-md'>
          <span className='pl-3 font-bold capitalize' style={{color: '#4B5563'}}> {`${status} (${count ?? 0})`}</span>
          <img 
            alt='arrow-icon' 
            src={arrow_tip_dark} 
            className={`text-gray-300 ml-6 mt-1.5 h-3 w-3 transform group-hover:text-gray-400 transition-colors ease-in duration-1000  ${showItem ? 'rotate-180' : '-rotate-90'}`} 
          />
        </div>
      </div>
    </div>
  )
}

export default DropdownTable